import { render, staticRenderFns } from "./dons.vue?vue&type=template&id=3be73204"
import script from "./dons.vue?vue&type=script&lang=js"
export * from "./dons.vue?vue&type=script&lang=js"
import style0 from "./dons.vue?vue&type=style&index=0&id=3be73204&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports